export default "__VITE_ASSET__CA1Xs4Z6__"